module.exports = __webpack_public_path__ + "static/media/Inselo Logo white.8f694dde.png";